mutation DeleteSentenceGroupCategory($id: ID!) {
  deleteSentenceGroupCategory(id: $id) {
    ok
    errors
  }
}
